import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import FacilityMarker from './FacilityMarker';

export function FacilityMarkers({
	facilities,
	highlightedFacility,
	phone,
	getLocalPhoneNumberByZipCode,
	preselectedFacilityId,
	onMarkerHover,
	onMarkerLeave,
	onScrollToFacility,
	searchParams,
	searchType,
	baseUrl,
	onShowMapFacilityCard,
	isNewSearchPage,
}) {
	return (
		<div>
			{map(facilities, (facility, index) => (
				<FacilityMarker
					position={facility.location}
					key={facility.id}
					offsetY={0}
					zIndex={index}
					facility={facility}
					phone={phone}
					ariaLabel={facility.name ? `${facility.name}${facility.distance ? ` - ${facility.distance} miles away` : ''}` : undefined}
					getLocalPhoneNumberByZipCode={getLocalPhoneNumberByZipCode}
					highlighted={
						facility.id === highlightedFacility ||
						facility.id === preselectedFacilityId
					}
					isPreselectedFacility={
						facility.id === preselectedFacilityId
					}
					onMarkerHover={onMarkerHover}
					onMarkerLeave={onMarkerLeave}
					onScrollToFacility={onScrollToFacility}
					searchParams={searchParams}
					searchType={searchType}
					baseUrl={baseUrl}
					onShowMapFacilityCard={onShowMapFacilityCard}
					isNewSearchPage={isNewSearchPage}
				/>
			))}
		</div>
	);
}

FacilityMarkers.propTypes = {
	getLocalPhoneNumberByZipCode: PropTypes.func,
	facilities: PropTypes.arrayOf(PropTypes.object),
	highlightedFacility: PropTypes.number,
	phone: PropTypes.object,
	preselectedFacilityId: PropTypes.number,
	onMarkerHover: PropTypes.func,
	onMarkerLeave: PropTypes.func,
	onScrollToFacility: PropTypes.func,
	searchParams: PropTypes.object,
	searchType: PropTypes.string,
	baseUrl: PropTypes.string,
	onShowMapFacilityCard: PropTypes.func,
	isNewSearchPage: PropTypes.bool,
};

export default FacilityMarkers;
